var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7861 1.78066C20.0421 2.08621 19.2531 2.28693 18.4452 2.37619C19.2964 1.90297 19.9333 1.15865 20.2372 0.281881C19.4377 0.723552 18.5612 1.03308 17.6486 1.20052C17.0349 0.591031 16.2215 0.186817 15.3349 0.0507149C14.4482 -0.0853868 13.5379 0.0542504 12.7456 0.447918C11.9532 0.841585 11.3232 1.46723 10.9534 2.22758C10.5836 2.98793 10.4948 3.84039 10.7007 4.65243C9.07925 4.57712 7.49296 4.18607 6.04486 3.50468C4.59677 2.82329 3.31925 1.8668 2.29527 0.697305C1.93285 1.27514 1.7424 1.93201 1.74342 2.60065C1.74342 3.91299 2.46394 5.07237 3.55692 5.75117C2.90953 5.73222 2.2764 5.56993 1.71027 5.27782V5.32398C1.71024 6.19815 2.03595 7.04543 2.63216 7.7221C3.22837 8.39877 4.05837 8.86317 4.98139 9.03654C4.38044 9.18788 3.75025 9.21017 3.13864 9.10171C3.39889 9.85417 3.90617 10.5122 4.58944 10.9837C5.2727 11.4552 6.09772 11.7164 6.94894 11.7309C6.10299 12.3477 5.13435 12.8036 4.09844 13.0725C3.06252 13.3415 1.97965 13.4183 0.911743 13.2985C2.77567 14.4111 4.94542 15.0019 7.16149 15C14.6631 15 18.764 9.23204 18.764 4.22976C18.764 4.06685 18.7601 3.90213 18.7523 3.74012C19.5502 3.20465 20.2389 2.54052 20.7861 1.78066Z",
    fill: "#C4E332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b9eae4217b8cbff9b04eb30f0bbfa389.svg";
export { ForwardRef as ReactComponent };